import React, {useRef, createContext, useContext, useEffect} from 'react';

import styled from 'styled-components';
import {useLocation} from 'react-router-dom';

const ScrollContainer = styled.div`
  // height: 100%;
  // overflow: scroll;
  width: 100%;
`;

export const ScrollContainerContext = createContext<
  {ref: React.MutableRefObject<null>} | undefined
>(undefined);

type ScrollContainerProvider = {};

export const ScrollContainerProvider: React.FC<ScrollContainerProvider> = ({children}) => {
  const ref = useRef(null);
  const {pathname} = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <ScrollContainerContext.Provider value={{ref}}>
      <ScrollContainer ref={ref}>{children}</ScrollContainer>
    </ScrollContainerContext.Provider>
  );
};

export const useScrollContainerContext = () => {
  const context = useContext(ScrollContainerContext);

  if (!context) {
    throw Error(`Context '${ScrollContainerContext}' not found`);
  }

  return context;
};

export default ScrollContainerProvider;
